import { render, staticRenderFns } from "./SettingsGoals.vue?vue&type=template&id=b3683b36&scoped=true&"
import script from "./SettingsGoals.vue?vue&type=script&lang=js&"
export * from "./SettingsGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3683b36",
  null
  
)

export default component.exports